import loadable from '@loadable/component';

export const PointsOfInterestModule = loadable(
    () =>
        import(
            /* webpackChunkName: "points-of-interest" */
            /* webpackPrefetch: true */
            './'
        ),
    {ssr: false}
);

PointsOfInterestModule.displayName = 'PointsOfInterestModule';
